"use client";

import Link from "next/link";
import { UnifiedForgotPasswordForm } from "@/components/auth/UnifiedForgotPasswordForm";

/**
 * Fashion Marketplace Forgot Password Page
 *
 * Served at kuttosfashion.com/forgot-password (prod) or fashion.localhost:3000/forgot-password (dev)
 * Sends a password reset email with a link to /reset-password on the same domain.
 */
export default function FashionForgotPasswordPage() {
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center p-4"
      style={{ backgroundColor: "#0f0f23" }}
    >
      <div className="w-full max-w-md">
        <div
          className="rounded-xl overflow-hidden"
          style={{
            backgroundColor: "#1a1a2e",
            border: "1px solid #2d2d44",
          }}
        >
          <UnifiedForgotPasswordForm
            signInPath="/signin"
            signUpPath="/signup"
            showBrandHint={true}
          />
        </div>

        {/* Footer */}
        <p className="mt-6 text-center text-sm text-gray-500">
          Powered by{" "}
          <Link
            href="https://kuttostechnologies.com"
            className="hover:text-gray-400 transition-colors"
          >
            Kuttos Technologies
          </Link>
        </p>
      </div>
    </div>
  );
}
